import React from "react";
import { useTextTranslate } from "../hooks/useTextTranslate";

const TranslateText = ({ text, fallback = "-", className = "", as: Component = "span" }) => {
    const translatedText = useTextTranslate(text || "");

    return (
        <Component className={className}>
            {translatedText || fallback}
        </Component>
    );
};

export default TranslateText;
